import type { AxiosResponse } from "axios";

export const isAxiosResponse = <T = any>(
  response: unknown
): response is AxiosResponse<T> => {
  return (
    response &&
    typeof response === "object" &&
    "data" in response &&
    "status" in response &&
    "statusText" in response &&
    "headers" in response &&
    "config" in response
  );
};
